module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image6h.ac65f417.jpg";